export default __webpack_public_path__ + "static/media/Spin torre RD_Interactive LightMix0062.411ed196.webp";